import React, { useState } from "react";
import { Field, FieldArray } from "formik";
import { Fields } from "@/uicomponents";
import "./form.scss";
import { constants } from "../../../services";
import { ModalFiles } from "../../Approvals";
import get from "lodash/get";
import CreateOrganization from "./createOrganization";
import NeighborOrganizations from "./neighborOrganizations";
import { useTranslation } from "react-i18next";

const Form = ({
  isSubmitting,
  isUpdate,
  values,
  errors,
  setStatus,
  status,
  leadType,
  selected,
}) => {
  const isOffline = leadType === "offline";

  const [createOrganization, setCreateOrganization] = useState(false);
  const [neighborsOpen, setNeighborsOpen] = useState(false);
  const { t } = useTranslation();

  if (isOffline) {
    return (
      <div className="!flex !flex-col !justify-between">
        <div className="flex flex-wrap -mx-2.5">
          <div className="relative w-full min-h-[1px] px-2.5 grow-0 shrink-0 basis-6/12 max-w-[50%]">
            <Field
              component={Fields.InputS1}
              name="customer_name"
              type="text"
              placeholder="Введите название"
              label={"Название"}
              size={"small"}
            />
          </div>
          <div className="relative w-full min-h-[1px] px-2.5 grow-0 shrink-0 basis-6/12 max-w-[50%]">
            <Field
              component={Fields.InputS1}
              name="phone"
              type="text"
              placeholder="Номер телефона"
              label={"Номер телефона"}
              size={"small"}
            />
          </div>
          <div className="relative w-full min-h-[1px] px-2.5 grow-0 shrink-0 basis-6/12 max-w-[50%]">
            <Field
              component={Fields.AsyncSelectS1}
              className="w-full"
              name="type_of_activity_id"
              placeholder="Вид деятельности"
              label={"Вид деятельности"}
              size={"small"}
              optionLabel="name"
              loadOptionsUrl="/activity-types"
              isSearchable={true}
              loadOptionsParams={(search) => {
                return { extra: { name: search } };
              }}
            />
          </div>
          <div className="relative w-full min-h-[1px] px-2.5 grow-0 shrink-0 basis-6/12 max-w-[50%]">
            <Field
              component={Fields.AsyncSelectS1}
              className="w-full"
              name="status_id"
              placeholder="Выберите статус лида"
              label={"Статус лида"}
              size={"small"}
              optionLabel="name"
              loadOptionsUrl="/lead-statuses"
              isSearchable={true}
              loadOptionsParams={(search) => ({
                extra: { name: search, group: 2 },
              })}
            />
          </div>
          <div className="relative w-full min-h-[1px] px-2.5 grow-0 shrink-0 basis-6/12 max-w-[50%]">
            <Field
              component={Fields.InputS1}
              name="quantity"
              type="number"
              placeholder="Количество"
              label={"Количество"}
              size={"small"}
            />
          </div>
          <div className="relative w-full min-h-[1px] px-2.5 grow-0 shrink-0 basis-6/12 max-w-[50%]">
            <Field
              component={Fields.SelectS1}
              className="w-full"
              name="type"
              placeholder="Выберите тип"
              label={"Тип"}
              size={"small"}
              optionLabel="name"
              options={[
                { id: constants.TYPE_ZIMZIM, name: "Zim-Zim" },
                { id: constants.TYPE_TRADE, name: "Trade" },
                { id: constants.TYPE_HR, name: "HR" },
                { id: constants.TYPE_LOOP, name: "Loop" },
              ]}
            />
          </div>
          <div className="relative w-full min-h-[1px] px-2.5 grow-0 shrink-0 basis-full max-w-full">
            <Field
              component={Fields.AsyncSelectS1}
              className="w-full"
              name="user_id"
              placeholder="Выберите менеджера"
              label={"Основной менеджер"}
              size={"small"}
              optionLabel="name"
              isSearchable={true}
              loadOptionsUrl="/user"
              loadOptionsParams={(search) => ({
                extra: { name: search },
              })}
            />
          </div>
          <div className="relative w-full min-h-[1px] px-2.5 grow-0 shrink-0 basis-full max-w-full">
            <Field
              component={Fields.AsyncSelectS1}
              className="w-full"
              name="user_ids"
              placeholder="Выберите доп. менеджеров"
              label={"Доп. менеджеры"}
              size={"small"}
              optionLabel="name"
              isSearchable={true}
              isMulti={true}
              loadOptionsUrl="/user"
              loadOptionsParams={(search) => ({
                extra: { name: search },
              })}
            />
          </div>
        </div>
        <div className="!flex !justify-end mt-24">
          <button
            type="submit"
            className={`d-btn d-btn-primary ${isSubmitting ? "--loading" : ""}`}
            disabled={isSubmitting}
          >
            {isUpdate ? "Сохранить" : "Добавить"}
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="!flex !flex-col !justify-between">
      <div className="flex flex-wrap -mx-2.5">
        <div className="relative w-full min-h-[1px] px-2.5 grow-0 shrink-0 basis-4/12 max-w-[33.333333%]">
          <Field
            component={Fields.InputS1}
            name="customer_name"
            type="text"
            placeholder="Введите название"
            label={"Название"}
            size={"small"}
          />
        </div>
        <div className="relative w-full min-h-[1px] px-2.5 grow-0 shrink-0 basis-4/12 max-w-[33.333333%]">
          <Field
            component={Fields.InputS1}
            name={`phone`}
            type="text"
            placeholder="Номер телефона"
            label={"Номер телефона"}
            size="small"
          />
        </div>
        <div className="relative w-full min-h-[1px] px-2.5 grow-0 shrink-0 basis-4/12 max-w-[33.333333%]">
          <Field
            component={Fields.AsyncSelectS1}
            className="w-full"
            name="type_of_activity_id"
            placeholder="Вид деятельности"
            label={"Вид деятельности"}
            size={"small"}
            optionLabel="name"
            loadOptionsUrl="/activity-types"
            isSearchable={true}
            loadOptionsParams={(search) => {
              return { extra: { name: search } };
            }}
          />
        </div>
        <div className="relative w-full min-h-[1px] px-2.5 grow-0 shrink-0 basis-4/12 max-w-[33.333333%]">
          <Field
            component={Fields.AsyncSelectS1}
            className="w-full"
            canUpdate={values.country_id && values.country_id.id}
            name="region_id"
            placeholder="Выберите регион"
            label={"Регион"}
            size={"small"}
            optionLabel="name"
            loadOptionsUrl="/regions"
            isSearchable={true}
            loadOptionsParams={(search) => ({
              filter: {
                country_id: values.country_id && values.country_id.id,
              },
              extra: { name: search },
            })}
          />
        </div>
        <div className="relative w-full min-h-[1px] px-2.5 grow-0 shrink-0 basis-4/12 max-w-[33.333333%]">
          <Field
            component={Fields.AsyncSelectS1}
            className="w-full"
            canUpdate={values.region_id && values.region_id.id}
            name="district_id"
            placeholder="Выберите район"
            label={"Район"}
            size={"small"}
            optionLabel="name"
            loadOptionsUrl="/districts"
            isSearchable={true}
            loadOptionsParams={(search) => ({
              filter: {
                region_id: values.region_id && values.region_id.id,
              },
              extra: { name: search },
            })}
          />
        </div>
        <div className="relative w-full min-h-[1px] px-2.5 grow-0 shrink-0 basis-4/12 max-w-[33.333333%]">
          <Field
            component={Fields.AsyncSelectS1}
            className="w-full"
            name="source_id"
            placeholder="Выберите источник"
            label={"Источник"}
            size={"small"}
            optionLabel="name"
            loadOptionsUrl="/sources"
            isSearchable={true}
            loadOptionsParams={(search) => ({
              extra: { name: search },
            })}
          />
        </div>
        <div className="relative w-full min-h-[1px] px-2.5 grow-0 shrink-0 basis-4/12 max-w-[33.333333%]">
          <Field
            component={Fields.AsyncSelectS1}
            className="w-full"
            name="status_id"
            placeholder="Выберите статус лида"
            label={"Статус лида"}
            size={"small"}
            optionLabel="name"
            handleChange={(option) => {
              setStatus(option.id);
            }}
            loadOptionsUrl="/lead-statuses"
            isSearchable={true}
            loadOptionsParams={(search) => ({
              extra: { name: search, group: leadType === "offline" ? 2 : 1 },
            })}
          />
        </div>
        <div className="relative w-full min-h-[1px] px-2.5 grow-0 shrink-0 basis-4/12 max-w-[33.333333%]">
          <Field
            component={Fields.SelectS1}
            className="w-full"
            name="type"
            placeholder="Выберите тип"
            label={"Тип"}
            size={"small"}
            optionLabel="name"
            options={[
              { id: constants.TYPE_ZIMZIM, name: "Zim-Zim" },
              { id: constants.TYPE_TRADE, name: "Trade" },
              { id: constants.TYPE_HR, name: "HR" },
              { id: constants.TYPE_LOOP, name: "Loop" },
            ]}
          />
        </div>
        <div className="relative w-full min-h-[1px] px-2.5 grow-0 shrink-0 basis-4/12 max-w-[33.333333%]">
          <Field
            component={Fields.SelectS1}
            className="w-full"
            name="quality"
            placeholder="Выберите статус качество"
            label={"Качество"}
            size={"small"}
            optionLabel="name"
            options={[
              { id: constants.QUALITY_HIGH, name: "Качественный" },
              { id: constants.QUALITY_LOW, name: "Некачественный" },
              {
                id: String(constants.QUALITY_UNDEFINED),
                name: "Неопределённый",
              },
            ]}
          />
        </div>
        <div className="relative w-full min-h-[1px] px-2.5 grow-0 shrink-0 basis-4/12 max-w-[33.333333%]">
          <Field
            component={Fields.SelectS1}
            className="w-full"
            name="agreement"
            placeholder="Выберите соглашение"
            label={"Соглашение"}
            size={"small"}
            optionLabel="name"
            options={[
              {
                id: constants.AGREEMENT_UNDEFINED,
                name: "Не определено",
              },
              { id: constants.AGREEMENT_YES, name: "Согласен" },
              { id: constants.AGREEMENT_NO, name: "Не согласен" },
            ]}
          />
        </div>
        <div className="relative w-full min-h-[1px] px-2.5 grow-0 shrink-0 basis-4/12 max-w-[33.333333%] mb-2">
          <Field
            component={Fields.NewDatePicker}
            name="agreement_at"
            label="Дата согласия"
            placeholder="DD.MM.YYYY"
            format="dd.MM.yyyy"
            className="w-full mb-0"
          />
        </div>
        <div className="relative w-full min-h-[1px] px-2.5 grow-0 shrink-0 basis-4/12 max-w-[33.333333%] mb-2">
          <Field
            component={Fields.AsyncSelectS1}
            className="w-full"
            name="user_id"
            placeholder="Выберите менеджера"
            label={"Основной менеджер"}
            size={"small"}
            optionLabel="name"
            loadOptionsUrl="/user"
            isSearchable={true}
            loadOptionsParams={(search) => ({
              extra: { name: search },
            })}
          />
        </div>
        <div className="relative w-full min-h-[1px] px-2.5 grow-0 shrink-0 basis-4/12 max-w-[33.333333%] mb-2">
          <Field
            component={Fields.AsyncSelectS1}
            className="w-full"
            name="user_ids"
            placeholder="Выберите доп. менеджеров"
            label={"Доп. менеджеры"}
            size={"small"}
            optionLabel="name"
            loadOptionsUrl="/user"
            isSearchable={true}
            isMulti={true}
            loadOptionsParams={(search) => ({
              extra: { name: search },
            })}
          />
        </div>
        <div className="relative w-full min-h-[1px] px-2.5 grow-0 shrink-0 basis-4/12 max-w-[33.333333%] mb-2">
          <Field
            component={Fields.NewDatePicker}
            name="created_at"
            label="Дата"
            placeholder="DD.MM.YYYY"
            format="dd.MM.yyyy"
            className="w-full mb-0"
          />
        </div>
        {status === 12 && (
          <div className="relative w-full min-h-[1px] px-2.5 grow-0 shrink-0 basis-4/12 max-w-[33.333333%] mb-2">
            <Field
              component={Fields.AsyncSelectS1}
              className="w-full"
              name="cancellation_reason_id"
              placeholder="Выберите причину"
              label={"Причины отмены лида"}
              size={"small"}
              optionLabel="name"
              loadOptionsUrl="/lead-cancellation-reasons"
              isSearchable={true}
              loadOptionsParams={(search) => ({
                extra: { name: search },
              })}
            />
          </div>
        )}
        {isUpdate && (
          <>
            <div className="relative w-full min-h-[1px] px-2.5 grow-0 shrink-0 basis-4/12 max-w-[33.333333%] mb-2">
              <Field
                component={Fields.NewDatePicker}
                name="sold_at"
                label="Дата продажи"
                placeholder="DD.MM.YYYY"
                format="dd.MM.yyyy"
                className="w-full mb-0"
                required={false}
              />
            </div>
            <div className="relative w-full min-h-[1px] px-2.5 grow-0 shrink-0 basis-4/12 max-w-[33.333333%] mb-2">
              <Field
                component={Fields.NewDatePicker}
                name="installed_at"
                label="Дата установки"
                placeholder="DD.MM.YYYY"
                format="dd.MM.yyyy"
                className="w-full mb-0"
                required={false}
              />
            </div>
          </>
        )}

        <div className="relative w-full min-h-[1px] px-2.5 grow-0 shrink-0 basis-4/12 max-w-[33.333333%] mb-2">
          <Field
            component={Fields.NewDatePicker}
            name="meeting_at"
            label="Дата встречи"
            placeholder="DD.MM.YYYY"
            format="dd.MM.yyyy"
            className="w-full mb-0"
            isRequired={!!values.meeting_status}
          />
        </div>
        <div className="relative w-full min-h-[1px] px-2.5 grow-0 shrink-0 basis-4/12 max-w-[33.333333%]">
          <Field
            component={Fields.SelectS1}
            className="w-full"
            name="meeting_status"
            placeholder="Выберите статус"
            label={
              <>
                Статус встречи{" "}
                {!!values.meeting_at && <span style={{ color: "red" }}>*</span>}
              </>
            }
            size={"small"}
            optionLabel="name"
            options={[
              {
                id: 0,
                name: "Не определено",
              },
              { id: 1, name: "В процессе" },
              { id: 2, name: "Завершена" },
              {
                id: -1,
                name: "Отменена",
              },
            ]}
          />
        </div>
      </div>

      {get(selected, "files", []).length > 0 && (
        <ModalFiles files={get(selected, "files", [])} />
      )}
      <div className="w-full px-2.5 mt-2">
        <div className="p-3.5 bg-slate-50/80 rounded-xl border border-slate-200">
          <FieldArray name="contacts">
            {({ push, remove }) => {
              return (
                <>
                  <div className="flex items-center justify-between mb-2">
                    <div className="text-xs font-semibold text-slate-700 uppercase tracking-wider flex items-center gap-2">
                      <span>Контакты</span>
                      <span className="text-[11px] px-2 py-0.5 rounded-full bg-slate-200/80 text-slate-600 font-medium">
                        {(values.contacts || []).length}
                      </span>
                    </div>
                    <button
                      type="button"
                      className="d-btn d-btn-outline d-btn-sm !py-1 !px-2.5 !rounded-lg !text-xs !font-medium !text-primary !border-primary/40 hover:!bg-primary/5 transition !inline-flex !items-center !gap-1"
                      onClick={() =>
                        push({ name: "", position: "", phone: "" })
                      }
                    >
                      + Добавить контакт
                    </button>
                  </div>

                  {(values.contacts || []).map((item, index) => {
                    const fieldErrors =
                      (errors && errors.contacts && errors.contacts[index]) ||
                      {};

                    return (
                      <div
                        key={index}
                        className="flex flex-wrap md:flex-nowrap items-start gap-2.5 p-2.5 mb-2 bg-white rounded-lg border border-slate-200/80 shadow-xs"
                      >
                        <div className="flex-1 min-w-[120px]">
                          <Field
                            component={Fields.InputS1}
                            name={`contacts[${index}].name`}
                            type="text"
                            placeholder="Имя"
                            label="Имя"
                            size="small"
                          />
                          {fieldErrors.name && (
                            <div className="text-red-500 text-xs mt-1">
                              {fieldErrors.name}
                            </div>
                          )}
                        </div>

                        <div className="flex-1 min-w-[120px]">
                          <Field
                            component={Fields.InputS1}
                            name={`contacts[${index}].position`}
                            type="text"
                            placeholder="Должность"
                            label="Должность"
                            size="small"
                          />
                          {fieldErrors.position && (
                            <div className="text-red-500 text-xs mt-1">
                              {fieldErrors.position}
                            </div>
                          )}
                        </div>

                        <div className="flex-1 min-w-[120px]">
                          <Field
                            component={Fields.InputMaskS1}
                            name={`contacts[${index}].phone`}
                            type="text"
                            placeholder="Номер телефона"
                            label={"Номер телефона"}
                            size="small"
                          />
                          {fieldErrors.phone && (
                            <div className="text-red-500 text-xs mt-1">
                              {fieldErrors.phone}
                            </div>
                          )}
                        </div>

                        <button
                          type="button"
                          onClick={() => remove(index)}
                          className="w-8 h-8 mt-5 flex items-center justify-center rounded-lg text-slate-400 hover:text-red-500 hover:bg-red-50 border border-slate-200 hover:border-red-200 transition shrink-0"
                          title="Удалить"
                        >
                          ✕
                        </button>
                      </div>
                    );
                  })}

                  {isUpdate && (
                    <div className="flex flex-wrap items-center gap-2 mt-3 pt-3 border-t border-slate-200">
                      {get(selected, "organization") ? (
                        <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg bg-emerald-50 border border-emerald-200 text-emerald-700 text-xs font-semibold">
                          ✓ {get(selected, "organization.name", "")} уже создана
                        </span>
                      ) : (
                        <button
                          type="button"
                          className={`d-btn d-btn-sm !py-1 !px-3 !rounded-lg !text-xs !font-medium !inline-flex !items-center !gap-1.5 transition ${
                            createOrganization
                              ? "!bg-blue-600 !text-white !border-blue-600"
                              : "!bg-blue-50 !text-blue-700 !border-blue-200 hover:!bg-blue-100"
                          }`}
                          onClick={() => setCreateOrganization((v) => !v)}
                        >
                          <span>Создать организацию</span>
                          <span
                            className={`transition-transform duration-200 ${
                              createOrganization ? "rotate-180" : ""
                            }`}
                          >
                            ▾
                          </span>
                        </button>
                      )}

                      <button
                        type="button"
                        className={`d-btn d-btn-sm !py-1 !px-3 !rounded-lg !text-xs !font-medium !inline-flex !items-center !gap-1.5 transition ${
                          neighborsOpen
                            ? "!bg-emerald-600 !text-white !border-emerald-600"
                            : "!bg-emerald-50 !text-emerald-700 !border-emerald-200 hover:!bg-emerald-100"
                        }`}
                        onClick={() => setNeighborsOpen((v) => !v)}
                      >
                        <span>Соседние организации</span>
                        <span
                          className={`transition-transform duration-200 ${
                            neighborsOpen ? "rotate-180" : ""
                          }`}
                        >
                          ▾
                        </span>
                      </button>
                    </div>
                  )}

                  <div className="w-full px-0 mt-2">
                    <div
                      className={`org-create-wrap ${
                        createOrganization ? "org-create-wrap--open" : ""
                      }`}
                    >
                      <CreateOrganization
                        isOpen={createOrganization}
                        onClose={() => setCreateOrganization(false)}
                        onSuccess={() => setCreateOrganization(false)}
                        leadId={get(selected, "id")}
                        regionId={get(values, "region_id.id")}
                        districtId={get(values, "district_id.id")}
                      />
                    </div>
                  </div>

                  <div className="w-full px-0">
                    <NeighborOrganizations
                      isOpen={neighborsOpen}
                      regionId={get(values, "region_id.id")}
                      districtId={get(values, "district_id.id")}
                    />
                  </div>
                </>
              );
            }}
          </FieldArray>
        </div>
      </div>

      <div className="sticky bottom-0 bg-white/95 backdrop-blur-xs py-3 px-2.5 border-t border-slate-200 mt-4 flex justify-end">
        <button
          type="submit"
          className={`d-btn d-btn-primary !px-6 !py-2.5 !rounded-lg !font-medium !shadow-sm hover:!shadow transition ${
            isSubmitting ? "--loading" : ""
          }`}
          disabled={isSubmitting}
        >
          {isUpdate ? "Сохранить" : "Добавить"}
        </button>
      </div>
    </div>
  );
};

export default Form;
